import {
  ArrowDown, ArrowUp, Crop, FileText, RotateCw, Star, TextCursorInput, Trash2,
} from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

const ASPECTS = [
  ["16:9", "Web 16:9", "Portada del diario · 1600×900"],
  ["4:5", "IG 4:5", "Instagram vertical · 1080×1350"],
  ["1:1", "1:1", "Cuadrada · 1080×1080"],
  ["9:16", "Story", "Historias y reels · 1080×1920"],
];

export const ImageRow = ({
  url, index, total, isFeatured, caption, busy,
  onFeature, onInsert, onEditMeta, onCaption, onTransform, onMove, onRemove,
}) => (
  <div
    className={`border p-4 flex flex-col md:flex-row gap-4 ${isFeatured ? "border-primary" : "border-border"}`}
    data-testid={`image-row-${index}`}
  >
    <img src={url} alt="" className="w-full md:w-48 h-32 object-cover rounded-sm shrink-0" />
    <div className="flex-1 min-w-0">
      <div className="flex items-center gap-2 mb-2">
        {isFeatured ? (
          <span className="kicker text-primary">Portada</span>
        ) : (
          <Button size="sm" variant="ghost" onClick={onFeature} data-testid={`set-featured-${index}`}>
            <Star className="h-3.5 w-3.5 mr-1.5" />Usar como portada
          </Button>
        )}
        <Button size="sm" variant="ghost" onClick={onInsert} data-testid={`insert-body-${index}`}>
          <TextCursorInput className="h-3.5 w-3.5 mr-1.5" />Insertar en el cuerpo
        </Button>
        <Button size="sm" variant="ghost" onClick={onEditMeta} data-testid={`image-meta-${index}`}>
          <FileText className="h-3.5 w-3.5 mr-1.5" />Datos para WordPress
        </Button>
      </div>
      <Input
        placeholder="Pie de foto"
        defaultValue={caption}
        onBlur={(e) => e.target.value !== caption && onCaption(e.target.value)}
        className="mb-3"
        data-testid={`caption-input-${index}`}
      />
      <div className="flex flex-wrap gap-1.5">
        <Button size="sm" variant="outline" onClick={() => onTransform({ rotate: 90 }, "rotada")}
                disabled={busy} data-testid={`rotate-${index}`}>
          <RotateCw className="h-3.5 w-3.5" />
        </Button>
        {ASPECTS.map(([value, label, hint]) => (
          <Button key={value} size="sm" variant="outline" title={hint}
                  onClick={() => onTransform({ aspect: value }, `recortada a ${label}`)}
                  disabled={busy} data-testid={`crop-${value.replace(":", "-")}-${index}`}>
            <Crop className="h-3.5 w-3.5 mr-1" />{label}
          </Button>
        ))}
        <Button size="sm" variant="outline" onClick={() => onMove(-1)} disabled={index === 0}
                data-testid={`move-up-${index}`}>
          <ArrowUp className="h-3.5 w-3.5" />
        </Button>
        <Button size="sm" variant="outline" onClick={() => onMove(1)} disabled={index === total - 1}
                data-testid={`move-down-${index}`}>
          <ArrowDown className="h-3.5 w-3.5" />
        </Button>
        <Button size="sm" variant="outline" onClick={onRemove} data-testid={`remove-image-${index}`}>
          <Trash2 className="h-3.5 w-3.5" />
        </Button>
      </div>
    </div>
  </div>
);
